import { render, staticRenderFns } from "./SswgMenu.vue?vue&type=template&id=50c5037a&scoped=true"
import script from "./SswgMenu.vue?vue&type=script&lang=js"
export * from "./SswgMenu.vue?vue&type=script&lang=js"
import style0 from "./SswgMenu.vue?vue&type=style&index=0&id=50c5037a&prod&lang=scss&scoped=true"
import style1 from "./SswgMenu.vue?vue&type=style&index=1&id=50c5037a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c5037a",
  null
  
)

export default component.exports